import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "card-title mt-0" }

import { computed, onMounted, ref } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n';
import { useRoute, useRouter } from 'vue-router';
import TargetDevice from '@/components/Firmware/BulkUpdate/TargetDevice.vue';
import ApplyDate from '@/components/Firmware/BulkUpdate/ApplyDate.vue';
import UpdateVersion from '@/components/Firmware/BulkUpdate/UpdateVersion.vue';
import VersionNote from '@/components/Firmware/BulkUpdate/VersionNote.vue';
import RemoveDeviceSearch from '@/components/Firmware/BulkUpdate/RemoveDeviceSearch.vue';
import FirmwareVersionsType from '@/types/FirmwareVersionsType';
import FirmwareTargetDeviceType from '@/types/FirmwareTargetDeviceType';
import { formatDateTimeWithSeconds } from '@/services/functions';
import FirmwareBulkUpdateExclusionType from '@/types/FirmwareBulkUpdateExclusionType';
import createFirmwareBulkUpdateSettingRequest from '@/types/requests/createFirmwareBulkUpdateSettingRequest';
import getDevice from '@/types/responses/getDevice';


export default /*@__PURE__*/_defineComponent({
  __name: 'BulkUpdateFormView',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const now = new Date()
now.setHours(0, 0, 0, 0)
const route = useRoute()
const router = useRouter();

const props = __props

const targetDevice = ref<FirmwareTargetDeviceType>({
  category: '',
  target: undefined
})
const applyDate = ref<Date>(now)
const updateVersion = ref<FirmwareVersionsType>()
const updateVersionId = ref<number | undefined>(undefined)
const removeDeviceIds = ref<number[]>([])
const removeDevices = ref<getDevice[]>([])
const errorMessages = ref<{[key: string]: string[]}>({})
const targetErrorMessages = ref<{[key: string]: string[]}>({})
const removeDeviceErrorMessages = ref<string[]>([])
const updateResultErrorMessages = ref<string>('')
const isLoading = ref(false)
const isEdit = computed(() => !!route.params.id)

onMounted(() => {
  if (isEdit.value) {
    fetchBulkUpdateData()
  }
})

function fetchBulkUpdateData() {
  isLoading.value = true
  resetErrorMessages()

  const settingId = Number(route.params.id);
  Api().getFirmwareBulkUpdateSetting(settingId).then((data) => {
    targetDevice.value = {
      category: data.target_category,
      target: {id: data.target_id} as FirmwareTargetDeviceType['target']
    }
    applyDate.value = new Date(data.activation_date)
    updateVersionId.value = data.firmware_id
    removeDeviceIds.value = data.firmware_bulk_update_exclusions.map(
      (item: FirmwareBulkUpdateExclusionType) => item.device_id
    )
    removeDevices.value = data.firmware_bulk_update_exclusions.map(
      (item: FirmwareBulkUpdateExclusionType) => item.device
    )
    isLoading.value = false
  }).catch((error) => {
    isLoading.value = false
  })
}

function submitBulkUpdate() {
  isLoading.value = true
  resetErrorMessages()

  const isValid = validation()
  if (!isValid) {
    isLoading.value = false
    return
  }

  const params = {
    firmware_id: updateVersion.value?.id,
    activation_date: formatDateTimeWithSeconds(applyDate.value),
    target_category: targetDevice.value.category,
    target_id: targetDevice.value?.target?.id,
    remove_device_ids: removeDeviceIds.value
  } as createFirmwareBulkUpdateSettingRequest

  Api().createFirmwareBulkUpdateSetting(params).then(() => {
    isLoading.value = false
    props.showFlash(i18n.global.t('pages.common.messages.success'), 'success', true);
    router.push({name: 'FirmwareBulkUpdateList'});
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 400:
        updateResultErrorMessages.value = res.data.message
        break;
      case 422:
        errorMessages.value = res.data.errors
        targetErrorMessages.value['target_category'] = res.data.errors['target_category'] || []
        targetErrorMessages.value['target_id'] = res.data.errors['target_id'] || []
        removeDeviceErrorMessages.value = Object.entries(errorMessages.value)
          .filter(([key]) => key.includes('remove_device_ids'))
          .flatMap(([key, value]) => value);
    }
    isLoading.value = false
  })
}

function resetErrorMessages() {
  errorMessages.value = {}
  targetErrorMessages.value = {}
  updateResultErrorMessages.value = ''
}

function validation() {
  let isValid = true
  if (!targetDevice.value['category']) {
    targetErrorMessages.value['target_category'] = [i18n.global.t('pages.firmwareBulkUpdate.messages.validSelect')]
    isValid = false
  }
  if (targetDevice.value['category'] && !targetDevice.value['target']) {
    targetErrorMessages.value['target_id'] = [i18n.global.t('pages.firmwareBulkUpdate.messages.validSelect')]
    isValid = false
  }
  if (!updateVersion.value) {
    errorMessages.value['firmware_id'] = [i18n.global.t('pages.firmwareBulkUpdate.messages.validSelect')]
    isValid = false
  }
  if (!applyDate.value) {
    errorMessages.value['activation_date'] = [i18n.global.t('pages.firmwareBulkUpdate.messages.validSelect')]
    isValid = false
  }
  return isValid
}


return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.formTitle')), 1)
      ]),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(TargetDevice, {
                modelValue: targetDevice.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((targetDevice).value = $event)),
                errorMessages: targetErrorMessages.value
              }, null, 8, ["modelValue", "errorMessages"]),
              _createVNode(ApplyDate, {
                modelValue: applyDate.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((applyDate).value = $event)),
                errorMessages: errorMessages.value['activation_date']
              }, null, 8, ["modelValue", "errorMessages"]),
              _createVNode(UpdateVersion, {
                modelValue: updateVersion.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updateVersion).value = $event)),
                initialItemId: updateVersionId.value,
                errorMessages: errorMessages.value['firmware_id']
              }, null, 8, ["modelValue", "initialItemId", "errorMessages"]),
              _createVNode(VersionNote, {
                note: updateVersion.value?.memo
              }, null, 8, ["note"]),
              (updateResultErrorMessages.value)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "fw-bold" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_textarea, {
                            label: "error messages",
                            class: "text-red mt-4",
                            modelValue: updateResultErrorMessages.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updateResultErrorMessages).value = $event)),
                            clearable: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, {
            inset: "",
            vertical: ""
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(RemoveDeviceSearch, {
                modelValue: removeDeviceIds.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((removeDeviceIds).value = $event)),
                removeDevices: removeDevices.value,
                errorMessages: removeDeviceErrorMessages.value
              }, null, 8, ["modelValue", "removeDevices", "errorMessages"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "d-flex justify-content-center align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: {name: isLoading.value ? null : 'FirmwareBulkUpdateList'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "reset-btn mr-2",
                    disabled: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.btn.cancel')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["to"]),
              (!isEdit.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "exec-btn ml-2",
                    loading: isLoading.value,
                    onClick: submitBulkUpdate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.btn.apply')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})